export default "__VITE_ASSET__6GmsRvck__"